import { createContext } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export const ReCaptchaContext = createContext<{
  disabled: boolean
}>({
  disabled: false
})

/**
 * Wrapper for the GoogleReCaptchaProvider to be able to disable the recaptcha
 * See: https://yes-technology.atlassian.net/browse/YT-6834
 * @param param0
 * @returns
 */
const ReCaptchaProvider = ({
  children,
  reCaptchaKey,
  disabled = false
}: {
  reCaptchaKey: string
  children: React.ReactNode
  disabled?: boolean
}) => {
  return (
    <ReCaptchaContext.Provider value={{ disabled }}>
      {disabled ? (
        <>{children}</>
      ) : (
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
          {children}
        </GoogleReCaptchaProvider>
      )}
    </ReCaptchaContext.Provider>
  )
}

export default ReCaptchaProvider
